import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('theme') || 'light';
  });

  useEffect(() => {
    localStorage.setItem('theme', theme);
    document.documentElement.classList.remove('light', 'dark');
    document.documentElement.classList.add(theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'light' ? 'dark' : 'light');
  };

  const getThemeClasses = () => {
    // Only Amber theme - original design
    return {
      primary: 'bg-amber-600 hover:bg-amber-700',
      primaryText: 'text-amber-600 dark:text-amber-500',
      primaryBorder: 'border-amber-600',
      primaryFocus: 'focus:border-amber-500 focus:ring-amber-200',
      gradient: 'bg-gradient-to-br from-amber-100 via-orange-50 to-rose-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900',
      lightBg: 'bg-amber-50 dark:bg-amber-900/20',
      heroText: 'text-gray-900 dark:text-white',
      sectionBg: 'bg-white dark:bg-gray-900'
    };
  };

  const value = {
    theme,
    setTheme,
    toggleTheme,
    isDark: theme === 'dark',
    isLight: theme === 'light',
    getThemeClasses
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};